// @flow
import { Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';
import { CashFlowTransaction } from 'data/transactions/types';

export const FrequencyEnum = Object.freeze({
  WEEKLY: 'WEEKLY',
  YEARLY: 'YEARLY',
  MONTHLY: 'MONTHLY',
  DAILY: 'DAILY',
});
export type Frequency = $Values<typeof FrequencyEnum>; // eslint-disable-line no-undef

export type RecurrenceType = {
  frequency: Frequency,
  interval: ?number,
  endOn: ?string,
  count: ?number,
  byMonthDay: ?Array<number>,
  byDay: ?Array<string>,
  byMonth: ?Array<number>,
  byYearDay: ?Array<number>,
  byMonthDayOrLastDay: ?Array<number>,
  byDates: ?Array<string>
};
export const mkRecurrence: RecordFactory<RecurrenceType> =
  Record({
    frequency: 'monthly',
    interval: undefined,
    endOn: null,
    count: null,
    byMonthDay: null,
    byDay: null,
    byMonth: null,
    byYearDay: null,
    byMonthDayOrLastDay: null,
    byDates: null,
  });

export const STTypeEnum = Object.freeze({
  EXPENSE: 'EXPENSE',
  INCOME: 'INCOME',
  TRANSFER: 'TRANSFER',
  BILL: 'BILL',
  SUBSCRIPTION: 'SUBSCRIPTION',
  UNKNOWN: 'UNKNOWN',
});
export type STType = $Values<typeof STTypeEnum>; // eslint-disable-line no-undef

type AutoAdjustAmount = 'AVERAGE_PAID' | 'EBILL_BALANCE_DUE' | 'EBILL_MINIMUM_DUE' | 'EBILL_STATEMENT_BALANCE' | 'TIME_OF_YEAR';
type ScheduledTransactionType = {
  id: ?string,
  clientId: ?string,
  isDeleted: ?boolean,
  createdAt: ?string,
  modifiedAt: ?string,
  userModifiedAt: ?string,
  dueOn: string,
  type: ?string,
  recurrence: RecurrenceType,
  transaction: CashFlowTransaction,
  overrideNextDueOn: ?string,
  overrideNextAmount: ?number,
  reminderDays: ?number,
  autoAcceptDays: ?number,
  autoSendDays: ?number,
  autoAdjustAmount: ?AutoAdjustAmount,
  averagePaidCount: ?number,
  paymentProvider: ?string,
  paymentModelId: ?string,
  billPresentmentProvider: ?string,
  billPresentmentModelId: ?string,
  relatedWebsite: ?string,
  printCheck: ?boolean,
  isCompleted: ?boolean,
  isUserVerified: ?boolean,
};

export type ScheduledTransaction = RecordOf<ScheduledTransactionType>;
export const mkScheduledTransaction: RecordFactory<ScheduledTransactionType> =
  Record({
    id: undefined,
    clientId: undefined,
    isDeleted: undefined,
    createdAt: undefined,
    modifiedAt: undefined,
    userModifiedAt: undefined,
    dueOn: undefined,
    type: undefined,
    recurrence: undefined,
    transaction: undefined,
    overrideNextDueOn: undefined,
    overrideNextAmount: undefined,
    reminderDays: undefined,
    autoAcceptDays: undefined,
    autoSendDays: undefined,
    autoAdjustAmount: undefined,
    averagePaidCount: undefined,
    paymentProvider: undefined,
    paymentModelId: undefined,
    billPresentmentProvider: undefined,
    billPresentmentModelId: undefined,
    relatedWebsite: undefined,
    printCheck: undefined,
    isCompleted: undefined,
    isUserVerified: undefined,
  });
